import { ImageBlockAlignment, ImageBlockData } from '../models';

export const isFloatedImageBlock = ({
  items,
  alignment,
}: Pick<ImageBlockData, 'items' | 'alignment'>): boolean =>
  items.length === 1 &&
  (alignment === ImageBlockAlignment.LEFT || alignment === ImageBlockAlignment.RIGHT);
